module.exports = __webpack_public_path__ + "static/img/6.eaad245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-fr/6.jpg
// module id = OfNu
// module chunks = 1